import { render, staticRenderFns } from "./HardwareResourceCard.vue?vue&type=template&id=de4a474c"
import script from "./HardwareResourceCard.vue?vue&type=script&lang=js"
export * from "./HardwareResourceCard.vue?vue&type=script&lang=js"
import style0 from "./HardwareResourceCard.vue?vue&type=style&index=0&id=de4a474c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports